export const narrowDown = {
  itemCategories: [
    {
      label: '全て',
      code: 'all',
    },{
      label: 'ヘルシー食',
      code: 'healthy',
    },{
      label: 'ヘルシー食多め',
      code: 'healthy_large',
    },{
      label: 'たんぱく質調整食',
      code: 'protein',
    },{
      label: 'ケア食',
      code: 'care',
    },{
      label: 'その他',
      code: 'extra'
    }
  ],
  itemSubCategories: [
    {
      label: 'おかず',
      code: 'okazu',
    }, {
      label: 'ごはん付',
      code: 'gohantsuki',
    }, {
      label: 'アラカルト',
      code: 'alacarte',
    }, {
      label: 'スイーツ',
      code: 'sweets',
    }
  ],
  withSubCategories: [
    {
      label: 'ヘルシー食 おかず',
      code: 'healthy_okazu',
    },{
      label: 'ヘルシー食 ごはん付',
      code: 'healthy_gohantsuki',
    },{
      label: 'ヘルシー食 アラカルト',
      code: 'healthy_alacarte',
    },{
      label: 'ヘルシー食 スイーツ',
      code: 'healthy_sweets',
    },{
      label: 'ヘルシー食多め おかず',
      code: 'healthy_large_okazu',
    },{
      label: 'ヘルシー食多め ごはん付',
      code: 'healthy_large_gohantsuki',
    },{
      label: 'たんぱく質調整食 おかず',
      code: 'protein_okazu',
    },{
      label: 'たんぱく質調整食 ごはん付',
      code: 'protein_gohantsuki',
    },{
      label: 'たんぱく質調整食 アラカルト',
      code: 'protein_alacarte',
    },{
      label: 'たんぱく質調整食 スイーツ',
      code: 'protein_sweets',
    },{
      label: 'ケア食 おかず',
      code: 'care_okazu',
    },{
      label: 'ケア食 ごはん付',
      code: 'care_gohantsuki',
    },{
      label: 'その他 スイーツ',
      code: 'extra_sweets'
    },{
      label: 'その他 アラカルト',
      code: 'extra_alacarte'
    }
  ],
  cookingStyle: [
    {
      label: '和風',
      code: 'japanese',
    }, {
      label: '洋風',
      code: 'western',
    }, {
      label: '中華',
      code: 'chinese',
    }, {
      label: '韓国風',
      code: 'korean',
    },
  ],
  seasonTags: [
    {
      label: '新商品',
      code: 'new',
    }, {
      label: '旬',
      code: 'season',
    },
  ],
  packingStyle: [
    {
      label: '単品',
      code: 'single',
    }, {
      label: 'セット',
      code: 'set',
    },
  ],
  other: [
    {
      label: 'おすすめ',
      code: 'recommend',
    }, {
      label: 'お気に入り',
      code: 'favorite',
    },
  ],
  allergen: [
    {
      label: 'えび',
      code: 'shrimp',
    }, {
      label: 'かに',
      code: 'crab',
    }, {
      label: '麦',
      code: 'malt',
    }, {
      label: 'そば',
      code: 'soba',
    }, {
      label: '卵',
      code: 'egg',
    }, {
      label: '乳',
      code: 'milk',
    }, {
      label: '落花生',
      code: 'peanut',
    },
  ]
}

export const setNarrowDown = {
  setCategory: [
    {
      index: 0,
      label: '特別セット',
      code: 'other',
    }, {
      index: 1,
      label: '栄養士セレクトセット',
      code: 'dietitian',
    }
  ]
}

export const dataSortCategories = [
  {
    index: 0,
    label: 'カタログコード',
    code: 'code',
  }, {
    index: 1,
    label: '販売価格',
    code: 'price',
  }, {
    index: 2,
    label: '内容量',
    code: 'weight',
  }, {
    index: 3,
    label: 'エネルギー',
    code: 'energy',
  }, {
    index: 4,
    label: 'たんぱく質',
    code: 'protein',
  }, {
    index: 5,
    label: '脂質',
    code: 'lipid',
  }, {
    index: 6,
    label: 'カリウム',
    code: 'potassium',
  }, {
    index: 7,
    label: 'リン',
    code: 'phosphorus',
  }, {
    index: 8,
    label: '食物繊維',
    code: 'fiber',
  }, {
    index: 9,
    label: '塩分',
    code: 'salt',
  }
]

export const dataSortOrders = [
  {
    index: 0,
    label: '昇順 ↑',
    code: 'asc',
  }, {
    index: 1,
    label: '降順 ↓',
    code: 'desc',
  }
]

export const itemDataUnit = [
  { index: '0', code: 'code', unit: '' },
  { index: '1', code: 'price', unit: '円' },
  { index: '2', code: 'weight', unit: 'g' },
  { index: '3', code: 'energy', unit: 'kcal' },
  { index: '4', code: 'protein', unit: 'g' },
  { index: '5', code: 'lipid', unit: 'g' },
  { index: '6', code: 'potassium', unit: 'mg' },
  { index: '7', code: 'phosphorus', unit: 'mg' },
  { index: '8', code: 'fiber', unit: 'g' },
  { index: '9', code: 'salt', unit: 'g' },
]